import { NgModule } from '@angular/core';
import { ImageViewerComponent } from './image-viewer.component';
import { CanvasDialogModule } from '../dialog';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [ImageViewerComponent],
  imports: [CommonModule,CanvasDialogModule],
  exports: [ImageViewerComponent]
})
export class ImageViewerModule {

}
